import useSWR from "swr";
import { type ReaderReport } from "../types";
import { simpleFetcher } from "../fetcher";

export const useReaderReport = (releaseId: number | undefined) => {
  return useSWR<ReaderReport, Error>(
    releaseId ? `/api/v2/document-releases/${releaseId}/readers` : null,
    simpleFetcher,
  );
};
